// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b897af24","46":"3bfeacf4","233":"221cc79c","622":"0a49918f","787":"a932adbb","817":"7e99258f"}[chunkId] + ".chunk.js";
};